var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var ready = require('./ready');

module.exports = function (socket, options) {
  options = options || {};
  options.closeOnEnd = options.closeOnEnd !== false;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _iterator.next();

            case 6:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 10;
              return _step.value;

            case 10:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 27;
                break;
              }

              data = _value;
              _context.prev = 13;
              _context.next = 16;
              return ready(socket);

            case 16:
              _context.next = 23;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](13);

              if (!(_context.t0.message === 'socket closed')) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("break", 27);

            case 22:
              throw _context.t0;

            case 23:
              socket.send(data);

            case 24:
              _iteratorNormalCompletion = true;
              _context.next = 4;
              break;

            case 27:
              _context.next = 33;
              break;

            case 29:
              _context.prev = 29;
              _context.t1 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 33:
              _context.prev = 33;
              _context.prev = 34;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 38;
                break;
              }

              _context.next = 38;
              return _iterator.return();

            case 38:
              _context.prev = 38;

              if (!_didIteratorError) {
                _context.next = 41;
                break;
              }

              throw _iteratorError;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(33);

            case 43:
              if (!(options.closeOnEnd && socket.readyState <= 1)) {
                _context.next = 45;
                break;
              }

              return _context.abrupt("return", new Promise(function (resolve, reject) {
                socket.addEventListener('close', function (event) {
                  if (event.wasClean || event.code === 1006) {
                    resolve();
                  } else {
                    var _err = Object.assign(new Error('ws error'), {
                      event: event
                    });

                    reject(_err);
                  }
                });
                setTimeout(function () {
                  return socket.close();
                });
              }));

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 29, 33, 43], [13, 18], [34,, 38, 42]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};